<p-dialog
  [modal]="true"
  [(visible)]="dialogVisible"
  (onHide)="onDialogHide()"
  [style]="{
    width: '80vw',
    height: '80vh',
    display: 'flex',
    'flex-direction': 'column',
  }"
  [contentStyle]="{
    display: 'flex',
    'flex-direction': 'column',
    flex: '1 1 auto',
    'min-height': '0',
    overflow: 'hidden',
    'padding-top': '0',
  }"
  [appendTo]="'body'"
  [dismissableMask]="true"
  [closable]="true"
  [blockScroll]="false"
>
  <ng-template #header>
    <div class="flex items-center gap-3 overflow-x-auto pr-2">
      @for (step of steps(); track step.number; let i = $index) {
        <div class="flex items-center gap-2 shrink-0">
          <div
            class="w-7 h-7 flex items-center justify-center text-sm font-semibold"
            [class.bg-primary-100]="
              isStepActive(step.number) || isStepCompleted(step.number)
            "
            [class.bg-surface-switch-200]="
              !isStepActive(step.number) && !isStepCompleted(step.number)
            "
            [class.text-primary]="
              isStepActive(step.number) || isStepCompleted(step.number)
            "
            [class.text-surface-switch-700]="
              !isStepActive(step.number) && !isStepCompleted(step.number)
            "
          >
            @if (isStepCompleted(step.number)) {
              <i class="pi pi-check"></i>
            } @else {
              {{ step.number }}
            }
          </div>
          <span
            class="text-md font-medium"
            [class.text-primary]="
              isStepActive(step.number) || isStepCompleted(step.number)
            "
            [class.text-muted-color]="
              !isStepActive(step.number) && !isStepCompleted(step.number)
            "
          >
            {{ step.label }}
          </span>
          @if (i < steps().length - 1) {
            <i class="pi pi-angle-right text-muted-color text-xs ml-1"></i>
          }
        </div>
      }
    </div>
  </ng-template>

  <div class="flex flex-col flex-1 min-h-0">
    <div class="flex-1 min-h-0">
      @if (currentStep() === 1) {
        <app-quote-item-upload-file
          class="block h-full min-h-0"
          [isBusy]="isPreparingCad()"
          [progress]="preparationProgress()"
          [statusText]="preparationStatus()"
          [processingError]="preparationError()"
          [cadFileNames]="preparingCadFileNames()"
          [multiple]="mode === 'bulk'"
          (stateCleared)="clearState()"
          (filesUploadRequested)="onCadFilesUploadRequested($event)"
          (filesUploaded)="onCadFilesUploaded($event)"
        />
      } @else if (
        (mode === "blueprint" || mode === "bulk") && currentStep() === 2
      ) {
        <app-quote-item-select-template
          class="block h-full min-h-0"
          [allBlueprints]="allBlueprints"
          [showSkip]="mode !== 'bulk'"
          [nextLabel]="mode === 'bulk' ? 'Save' : 'Next'"
          [nextIcon]="mode === 'bulk' ? 'pi pi-check' : 'pi pi-arrow-right'"
          (blueprintSelected)="onBlueprintSelected($event)"
          (next)="onSelectTemplateNext()"
          (back)="onSelectTemplateBack()"
          (skip)="onSkipTemplate()"
        />
      } @else {
        <app-quote-item-link-file
          class="block h-full min-h-0"
          [linkItems]="linkItems()"
          [loadedCadObjects]="latestCadObjects"
          (confirmed)="onLinkConfirmed($event)"
          (back)="onLinkFileBack()"
        />
      }
    </div>
  </div>
</p-dialog>
